export default __webpack_public_path__ + "11c5dca6d97c9e10e5b7a84c7471eb61.svg";